import React from 'react';
import { Introduction } from '../Components/Introduction';
import { ContactUsBlock } from '../Components/ContactUsBlock';
import { Link } from '@mui/material';
import { PageType } from '../../../utils/Pages'
import { AppHelmet } from '../../Common/AppHelmet';
import config from '../../../config/config.json';

export const GetToKnow = () => {
    const heading1 = {
        start: "Get to know the ",
        highlight: "SmartCard",
        body: <>Enhanced Income Management helps customers budget their payments to meet essential household needs and expenses like food, rent, bills and education.
                <br/><br/>When a customer gets their Centrelink payment, it will be in two parts. Some goes into their regular bank account and the rest goes to their enhanced Income Management account. Customers access their enhanced Income Management account with a SmartCard. There are some things customers cannot buy using money from this account.
                <br/><br/>Customers cannot use their SmartCard to:
                <ul>
                    <li>buy tobacco or tobacco products</li>
                    <li>buy pornography</li>
                    <li>buy alcohol or homebrew kits/concentrates</li>
                    <li>gamble</li>
                    <li>buy cash-like products and some gift cards</li>
                    <li>get cash out.</li>
                </ul>
          <br /><br />Services Australia delivers enhanced Income Management on behalf of the Australian Government.
          <br /><br />To find out more about enhanced Income Management, visit the website <Link href={config.SA_EIM_WEBSITE} target="_blank" rel="noopener noreferrer">Services Australia SmartCard page</Link>.
            </>
    };

    return (
        <>
            {AppHelmet.Add(PageType.GetToKnow)}
            <Introduction
                heading1={heading1}
            />
            <ContactUsBlock
                variant="violet"/>
        </>
    );
}
